var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_vm._m(0),_c('div',{staticClass:"action"},[_c('button',{staticClass:"md-raised md-primary",on:{"click":function($event){return _vm.login()}}},[_vm._v(" Login with LINE ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo.png"),"alt":"VIP by PMTT"}})])
}]

export { render, staticRenderFns }